import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseApi } from '../laas/base-api.service';
import { environment as ENV } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable()
export class AdminService {
  public zoneSelection: any = [];
  maxDate: any;
  getMonth: any;
  getYear: number;
  constructor(
    private snackbar: MatSnackBar,
    private api: BaseApi,
    public jwtHelper: JwtHelperService,
    private router: Router
  ) {}

  getCurrentMonth() {
    var todayDate = new Date();
    this.getMonth = todayDate.getMonth() + 1;
    console.log('month', this.getMonth);
    this.getYear = todayDate.getUTCFullYear();
    if (this.getMonth < 10) {
      this.getMonth = '0' + this.getMonth;
      console.log('add 0', this.getMonth);
    }
    return (this.maxDate = this.getYear + '-' + this.getMonth);
  }

  reloadComponent(routeLink: any) {
    this.router.navigateByUrl('/admin/setting', { skipLocationChange: true }).then(() => {
      this.router.navigate([routeLink]);
    });
  }

  createUser(value) {
    console.log('service call', value);
    const val = { ...value, userRole: '0' };
    return this.api.postRes(`/blg/createusers`, val).pipe(map((admin) => {
      console.log('checklogin: ', admin);
      return admin;
    }));
  }

  getOfficeCode(type: any) {
    return this.api.postRes('/blg/getZRBList', { type }).pipe(map((admin) => {
      return admin;
    }));
  }

  getBranchName() {
    let roleId = sessionStorage.getItem('getroleId');
    if (roleId == '1' || roleId == '11' || roleId == '12' || roleId == '7' || roleId == '8') {
      return 'Branch Name : Central Office';
    } else if (roleId == '2' || roleId == '21') {
      let zone_name = sessionStorage.getItem('zone_name');
      return `Branch Name : ${zone_name ? this.titleCase(zone_name) : ''}`;
    } else if (roleId == '3' || roleId == '31') {
      let ro_name = sessionStorage.getItem('ro_name');
      return `Branch Name : ${ro_name ? this.titleCase(ro_name) : ''}`;
    } else if (roleId == '4' || roleId == '41') {
      let branch_name = sessionStorage.getItem('branch_name');
      return `Branch Name : ${branch_name ? this.titleCase(branch_name) : ''}`;
    } else if (roleId == '5' || roleId == '51') {
      let branch_name = sessionStorage.getItem('branch_name');
      return `Branch Name : ${branch_name ? this.titleCase(branch_name) : ''}`;
    }
  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  getSolID() {
    let roleId = sessionStorage.getItem('getroleId');
    if (roleId == '1' || roleId == '11' || roleId == '12' || roleId == '7' || roleId == '8') {
      return 'Sol Id: 57365';
    } else if (roleId == '2' || roleId == '21') {
      let zonalCode = sessionStorage.getItem('zonal_code');
      return `Sol Id: ${zonalCode}`;
    } else if (roleId == '3' || roleId == '31') {
      let roCode = sessionStorage.getItem('ro_code');
      return `Sol Id: ${roCode}`;
    } else if (roleId == '4' || roleId == '41') {
      let branchCode = sessionStorage.getItem('branch_code');
      return `Sol Id: ${branchCode}`;
    } else if (roleId == '5' || roleId == '51') {
      let branchCode = sessionStorage.getItem('branch_code');
      return `Sol Id: ${branchCode}`;
    }
  }

  getCodeAndType() {
    let roleId = sessionStorage.getItem('getroleId');
    if (roleId == '0' || roleId == '1' || roleId == '11' || roleId == '12' || roleId == '7' || roleId == '8') {
      return {type:'',code:""};
    } else if (roleId == '2' || roleId == '21') {
      let zonalCode = sessionStorage.getItem('zonal_code');
      return {type:"zonal_code",code:zonalCode};
    } else if (roleId == '3' || roleId == '31') {
      let roCode = sessionStorage.getItem('ro_code');
      return {type:"ro_code",code:roCode};
    } else if (roleId == '4' || roleId == '41') {
      let branchCode = sessionStorage.getItem('branch_code');
      return {type:"branch_code",code:branchCode};
    } else if (roleId == '5' || roleId == '51') {
      let branchCode = sessionStorage.getItem('branch_code');
      return {type:"branch_code",code:branchCode};
    }
  }

  getUserRequest() {
    return this.api.getComplt('/blg/getUserRequestList').pipe(map((admin) => {
      return admin;
    }));
  }

  transferUserRequestList() {
    return this.api.getComplt('/blg/getTransferList').pipe(map((admin) => {
      console.log('transfer details: ', admin);
      return admin;
    }));
  }

  approveOrReject(value) {
    const val = { ...value };
    return this.api.postRes(`/blg/approveUserRequest`, val).pipe(map((admin) => {
      console.log('approve or reject: ', admin);
      // this.storeAdmin(admin);
      return admin;
    }));
  }

  transferRequest(value) {
    // const val = {...value, "addedBy":"066ddfa6-3fe5-4609-9220-0d05fca8282d"}
    return this.api.postRes(`/blg/transferUser`, value).pipe(map((admin) => {
      console.log('transfer: ', admin);
      // this.storeAdmin(admin);
      return admin;
    }));
  }

  transferAcceptOrReject(value) {
    //const val = {...value, "addedBy":"066ddfa6-3fe5-4609-9220-0d05fca8282d"}
    console.log('transer value', value);
    return this.api.postRes(`/blg/transferUser`, value).pipe(map((admin) => {
      console.log('transfer: ', admin);
      // this.storeAdmin(admin);
      return admin;
    }));
  }

  getUserRoleList() {
    return this.api.getComplt('/blg/getRolesList').pipe(map((admin) => {
      console.log('user role details: ', admin);
      return admin;
    }));
  }

  getAccessLevelList() {
    return this.api.getComplt('/blg/MISLevels').pipe(map((admin) => {
      console.log('Access Level List: ', admin);
      return admin;
    }));
  }

  getUserDetails(userId: string, staffId: string, roleId: string) {
    const params = new HttpParams()
      .set('userId', userId)
      .set('staffId', staffId)
      .set('roleId', roleId);

    // Make the GET request
    return this.api.getAll(`/blg/userDetails`, { params });
  }

  disableUser(userId: string, staffId: string, roleId: string, adminId: string) {
    return this.api.aPut(`/blg/disableUser`, { adminId, roleId, staffId, userId });
  }

  getSolIdDetails(solId) {
    const params = new HttpParams()
    .set('code', solId)
    return this.api.getAll(`/blg/sol-info`,{params});
  }

  getDropDownValues(
    combineAll: boolean,
    type: string,
    filter: string = '',
    codeType: string = '',
    code: string = ''
  ) {
    const params = new HttpParams()
      .set('all', combineAll.toString())
      .set('type', type)
      .set('filter', filter)
      .set(codeType, code);

    return this.api.getAll(`/blg/state-zrb-info`, { params });
  }

  getCropDistricts(userId){
    return this.api.postRes(`/blg/getcropdistricts`, {userId});
    // return of(districtList);
  }
}
